/** Layout and z-index constants shared across the mating-results table components. */

/** Fallback label when the society's EBV_AVERAGE config has no `description`. */
export const BREED_AVERAGE_FALLBACK_LABEL = 'Breed Average';

/** Extra scrollable space below the last row so the final group is easier to read. */
export const TABLE_SCROLL_BOTTOM_SPACING_PX = 32;

/** Default offset for sticky breed-averages row before header is measured (category + label rows). */
export const STICKY_HEADER_DEFAULT = 100;

export const STICKY_PRIMARY_ROW_BORDER = '2px solid';

/**
 * Visual gap between the sticky primary (sire/dam) row and snap-aligned secondary
 * rows. Spacer row height must match so scroll snap lands with this gap visible.
 */
export const PRIMARY_BELOW_GAP_PX = 20;

/** Sticky z-order: thead & breed stay above primary; primary above mating-block name cells */
export const Z_HEAD_NAME = 50;
/** Category group header row (above trait labels) */
export const Z_HEAD_CATEGORY = 49;
export const Z_HEAD_EBV = 48;
export const Z_BREED_NAME = 46;
export const Z_BREED_EBV = 44;
export const Z_PRIMARY_NAME = 42;
export const Z_PRIMARY_EBV = 40;
/**
 * Mate-block sticky name column above EBV cells in the same row (later `td` paints on top by default).
 * Below {@link Z_PRIMARY_EBV} so the primary row still covers these rows when vertically stacked.
 */
export const Z_MATE_STICKY_NAME = 36;
